<template>
  <div>
    <a ref="attachmentA"></a>
        <stepheader :step="step"/>
         <div id="wizard2-p-0" role="tabpanel" aria-labelledby="wizard2-h-0" class="body current" aria-hidden="false" style="">
         
           
        <div class="row">

            <div class="col-xl-3 col-md-6 col-sm-6 my-1"  v-for="item in attachments.filter(x=>x.attachmentTypeId ==attachmentTypeUpload)"
                 :key="item.attachmentId">
                <div class="card m-0 p-0 border">
                    <div class="d-flex align-items-center px-3 pt-3">
                        <div class="float-end ms-auto">
                            <a href="#" class="option-dots" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fe fe-more-vertical" ></i></a>
                            <div class="dropdown-menu dropdown-menu-start">
                                 <a class="dropdown-item" href="#" v-on:click.stop="removeAttachment(item.attachmentId)"><i class="fe fe-trash me-2"></i> Elimina</a>
                            </div>
                        </div>
                    </div>
                    <div class="card-body pt-0 text-center">
                        <div class="file-manger-icon">
                            <a href="#"  v-on:click.stop="downloadAttachment(item.attachmentId,item.originalFileName)">
                                <i class="fa-3x br-7 p-2"
                                   src=""
                                   :class="getExtensionIcon(item.fileExtension)"></i>
                               
                            </a>
                        </div>
                        <h6 class="mb-1 font-weight-semibold">{{item.title}}</h6>
                        <span class="text-muted">{{item.weight | prettyBytes }}</span>
                    </div>
                </div>
            </div>


        </div>
          <div class="row" >
            <!--v-if="attachments.filter(x=>x.attachmentTypeId == attachmentTypeUpload).length == 0"-->
           <div class="col-12">
           
            <vue-dropzone ref="myVueDropzone"
                              id="attachment-dropzone"
                              name="attachment-dropzone"
                              :options="dropzoneOptions()"
                              :useCustomSlot="true">
                    <div class="dropzone-custom-content dropify-message">
                        <h3 class="dropzone-custom-title">
                            Trascina i file qui per il caricamento
                        </h3>
                        <div class="subtitle">...o fai click per caricarlo dal tuo pc</div>
                    </div>
                </vue-dropzone>
          </div>
          </div>
          <buttons :buttons=step.buttons v-on:action="fireaction"></buttons>
											
 
  </div>
  </div>

</template>

<script>

import Swal from "sweetalert2";
import axios from "axios";

export default {
  name: "attachment",
  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    attachments:{
      type: Array,
      required: false,
      default: () => [],
    },
  ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
     attachmentTypeUpload:0,

    };
  },
  computed: {
   
  },
  components: {
   
  },
  mounted() {
    setTimeout(this.loaddata,100);
  },
  methods: {
      getExtensionIcon: function (ext) {
      if (ext) ext = ext.toLowerCase();
      else ext = "";
      switch (ext) {
        case ".txt":
          return "fa fa-file-text-o";
        case ".doc":
        case ".docx":
          return "fa fa-file-word-o  text-info";
        case ".xls":
        case ".xlsx":
        case ".csv":
          return "fa fa-file-excel-o text-success";
        case ".jpg":
        case ".jpeg":
        case ".png":
        case ".bmp":
        case ".tiff":
          return "fa fa-image  text-info";
        case ".pdf":
          return "fa fa-file-pdf-o text-danger";
        case ".wav":
        case ".mp3":
          return "fa fa-file-audio-o text-warning";
        case ".ppt":
        case ".pptx":
          return "fa fa-file-powerpoint-o text-warning";
        case ".zip":
        case ".rar":
        case ".7z":
          return "fa fa-file-archive-o  text-warning";
        default:
          return "fa fa-file-o";
      }
    },
    dropzoneOptions: function () {
      var me = this;
     
      function url() {
        return (
            window.baseurl +"/attachment/upload/" + me.attachmentTypeUpload +"/0" 
         
        );
      }
      return {
        url: url,
          headers: { Authorization: "Bearer " + localStorage.getItem("srwizardtoken") },
        success: function (a, b) {
          console.log(a,b)
          this.removeFile(a);
          me.attachments.push(b);
        },
      };
    },
    fireaction: function (action, nextstep) {
      console.log(`attachment.vue - action = ${action}`);
      var isRequired = this.step.required || window.uroles.filter(x => x == this.step.requiredRoles.toLowerCase()).length > 0
      switch (action) {
        case "next":
          if (this.attachments.filter(x => x.attachmentTypeId == this.attachmentTypeUpload).length == 0 && isRequired) {
            swal({
              title: "Errore di compilazione",
              text: "Caricare il file richiesto",
              type: "error",
              showCancelButton: false,
              toast: false,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });

          }
          else {
            this.$emit("goto", nextstep);

          }
          break;
        default:
          this.$emit("goto", nextstep);
          break;
      }

    },
    removeAttachment: function (id) {
      var me = this;
     swal({
        title: ``,
        html: `Sicuri di voler eliminare la risorsa?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
          axios.delete("attachment/" + id).then((response) => {
          me.attachments = me.attachments.filter(x=>x.attachmentId!=id);
          });
        }
      });
    },
    downloadAttachment: function (id, o) {
      var me = this;
      var url = "";
      axios
        .get(`attachment/download/${id}`, { responseType: "blob" })
        .then(function (result) {
          var blob = new Blob([result.data], {
            type: result.headers["content-type"],
          });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(blob, o);
          } else {
            me.$refs.attachmentA.href = URL.createObjectURL(blob);
            me.$refs.attachmentA.download = o;
            me.$refs.attachmentA.click();
          }
        });
    },
   loaddata: function () {
      axios.get(`tipiAllegato/code/${this.step.categorytype}`).then(response=>
      this.attachmentTypeUpload = response.data.attachmentTypeId
      )
    },

    authenticate:function(nextstep){

    }
  },
};
</script>